import PropTypes from 'prop-types'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import styles from './MediosDePago.module.css'

const MERCADO_PAGO = 7
const ENVIO_GRATIS = 1
const RETIRO_COMPRADOR = 2
const ENVIO_COMPRADOR = 3

const Medios = ({ data, titulo, listaEnvios = [], infoMediosEnvio = null }) => {
  return (
    <div className={`row ${styles.mediosPagoWrapper}`}>
      <div className="col">
        <p className={styles.tituloDetalle}>{titulo}</p>

        <div className={styles.listaMedios}>
          {data?.map((item) => {
            const idItem = item.idMedioPago || item.idMedioEnvio

            if (item.idMedioEnvio === ENVIO_COMPRADOR && listaEnvios && listaEnvios.length > 0) {
              const zonaCostoMap = new Map()
              listaEnvios.forEach((envio) => {
                envio.grilla?.forEach((grillaItem) => {
                  if (!zonaCostoMap.has(grillaItem.zona)) {
                    zonaCostoMap.set(grillaItem.zona, {
                      costo: grillaItem.costo,
                      tEstimado: grillaItem.tEstimado
                    })
                  }
                })
              })
              const tooltipContent = (
                <div>
                  {Array.from(zonaCostoMap.entries()).map(([zona, detalle]) => (
                    <div key={zona} style={{ whiteSpace: 'nowrap', fontSize: '0.9em' }}>
                      {zona} - ${detalle.costo} - Entrega aprox. - {detalle.tEstimado} dias
                    </div>
                  ))}
                  <h6>Para más zonas e importes ver en</h6>
                  <h6>Confirma los datos de envío continuando la compra</h6>
                </div>
              )

              return (
                <OverlayTrigger
                  key={`${item.icono}-${idItem}`}
                  placement="top"
                  overlay={<Tooltip className={styles.tooltipCustom}>{tooltipContent}</Tooltip>}
                >
                  <span className={styles.chipMedio}>{item.nombre}</span>
                </OverlayTrigger>
              )
            }

            if (item.idMedioEnvio === ENVIO_GRATIS || item.idMedioEnvio === RETIRO_COMPRADOR) {
              const esEnvioGratis = item.idMedioEnvio === ENVIO_GRATIS
              const zona = esEnvioGratis
                ? infoMediosEnvio?.descZona
                : infoMediosEnvio?.descZonaRetiro
              const dias = esEnvioGratis
                ? infoMediosEnvio?.cantDiasEnvioGratis
                : infoMediosEnvio?.cantDiasRetiroComprador

              const tieneZona = Boolean(zona)
              const tieneDias = dias !== null && dias !== undefined && dias !== ''

              if (tieneZona || tieneDias) {
                const tooltipContent = (
                  <div>
                    {tieneZona && (
                      <div style={{ whiteSpace: 'nowrap', fontSize: '0.9em' }}>
                        <strong>Zonas:</strong> {zona}
                      </div>
                    )}
                    {tieneDias && (
                      <div style={{ whiteSpace: 'nowrap', fontSize: '0.9em' }}>
                        Aprox. {dias} día{Number(dias) > 1 ? 's' : ''} de entrega
                      </div>
                    )}
                  </div>
                )

                return (
                  <OverlayTrigger
                    key={`${item.icono}-${idItem}`}
                    placement="top"
                    overlay={<Tooltip className={styles.tooltipCustom}>{tooltipContent}</Tooltip>}
                  >
                    <span className={styles.chipMedio}>{item.nombre}</span>
                  </OverlayTrigger>
                )
              }
            }

            return (
              <span
                key={`${item.icono}-${idItem}`}
                className={styles.chipMedio}
                {...(item.idMedioPago === MERCADO_PAGO && { title: item.descripcion })}
              >
                {item.nombre}
              </span>
            )
          })}
        </div>
      </div>
    </div>
  )
}

Medios.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      icono: PropTypes.string,
      idMedioPago: PropTypes.number,
      idMedioEnvio: PropTypes.number,
      nombre: PropTypes.string,
      descripcion: PropTypes.string
    })
  ).isRequired,
  titulo: PropTypes.string.isRequired,
  listaEnvios: PropTypes.arrayOf(
    PropTypes.shape({
      grilla: PropTypes.arrayOf(
        PropTypes.shape({
          zona: PropTypes.string,
          costo: PropTypes.number,
          tEstimado: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        })
      )
    })
  ),
  infoMediosEnvio: PropTypes.object
}

export default Medios
